var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-theme":_vm.theme}},[_c('SkipToContent'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('CommandBar',{ref:"commandbar",attrs:{"commands":_vm.commands}}),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }